import { render, staticRenderFns } from "./aliVideo.vue?vue&type=template&id=175c4c07&scoped=true"
import script from "./aliVideo.vue?vue&type=script&lang=js"
export * from "./aliVideo.vue?vue&type=script&lang=js"
import style0 from "./aliVideo.vue?vue&type=style&index=0&id=175c4c07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175c4c07",
  null
  
)

export default component.exports